import { render, staticRenderFns } from "./confirm-invitation.vue?vue&type=template&id=485e69d5&scoped=true&"
import script from "./confirm-invitation.vue?vue&type=script&lang=ts&"
export * from "./confirm-invitation.vue?vue&type=script&lang=ts&"
import style0 from "./confirm-invitation.vue?vue&type=style&index=0&id=485e69d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485e69d5",
  null
  
)

export default component.exports